module.exports = __webpack_public_path__ + "static/media/arrowUp_hoverActive.d2b58c12.svg";